import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getRefunds } from "api/refund.api";
import { gracefulList } from "lib/queryHelpers";
import { QUERY_KEYS } from "config/queryKeys";
import { DEFAULT_STALE_TIME } from "config/constants";

export const useGetRefunds = (params = {}) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: [...QUERY_KEYS.refunds.list(), params],
    queryFn: gracefulList(() => getRefunds(params), { refunds: [] }),
    initialData: () => queryClient.getQueryData(QUERY_KEYS.refunds.list()),
    select: (data) => data?.refunds ?? [],
    staleTime: DEFAULT_STALE_TIME,
  });
};
